import type { Editor } from "@tiptap/react";
import type { ForwardedRef } from "react";

import { EditorContent } from "@tiptap/react";
import clsx from "clsx";
import { twMerge } from "tailwind-merge";

import { MenuBar } from "./MenuBar";

export function EditorContainer({
  borderless,
  editor,
  isDisabled,
  isInvalid,
  isMinimal,
  isReadOnly = true,
  placeholder,
  ref,
}: {
  borderless?: boolean;
  editor: Editor;
  isDisabled?: boolean;
  isInvalid?: boolean;
  isMinimal?: boolean;
  isReadOnly: boolean;
  placeholder?: string;
  ref: ForwardedRef<HTMLDivElement>;
}) {
  return (
    <div
      className={twMerge(
        clsx(
          "flex h-full flex-col overflow-hidden",
          !borderless && [
            "rounded-md border border-border-primary bg-bg-primary",
            {
              "border-border-brand": Boolean(editor.isFocused) && !isInvalid,
              "border-border-error": isInvalid,
              "border-border-primary": Boolean(isDisabled),
            },
            {
              "ring-4": Boolean(editor.isFocused),
              "ring-border-brand/25": Boolean(editor.isFocused) && !isInvalid,
              "ring-border-error/25": Boolean(editor.isFocused) && isInvalid,
            },
          ],
        ),
      )}
    >
      {!isReadOnly && (
        <MenuBar
          disabled={Boolean(isDisabled)}
          editor={editor}
          isMinimal={isMinimal}
        />
      )}
      <EditorContent
        className="min-h-0 flex-1"
        editor={editor}
        placeholder={placeholder}
        ref={ref}
        role="textbox"
      />
    </div>
  );
}
